<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieInformationsExtend', 'salarie', false)">
      <v-col>
        <div class="section-abstract-title">Informations complémentaires</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Nom d'artiste</div>
            <div class="section-abstract-value">{{ salarie.pseudo }} <v-icon v-if="salarie.pseudo" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.pseudo, 0)">{{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Numéro de congé spectacle</div>
            <div class="section-abstract-value">{{ salarie.numeroCongeSpec }} <v-icon v-if="salarie.numeroCongeSpec" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.numeroCongeSpec, 1)">{{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Statut handicapé</div>
            <div class="section-abstract-value">{{ salarie.statutHandicapLabel }} <v-icon v-if="salarie.statutHandicap" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.statutHandicapLabel, 2)">{{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 2; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">DFS</div>
            <div class="section-abstract-value">{{ salarie.abattementLabel }} <v-icon v-if="salarie.abattement" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.abattementLabel, 3)">{{ copiedField === 3 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieFiscaliteExtend', 'salarie', false)">
      <v-col>
        <div class="section-abstract-title"></div>
        <div class="section-abstract-display">Fiscalit&#233;</div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
          <div class="section-abstract-value">{{ salarie.fiscaliteLabel }} <v-icon v-if="salarie.fiscaliteLabel" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(salarie.fiscaliteLabel, 3)">{{ copiedField === 3 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
 <script lang="ts">
  import { defineComponent } from "vue";
  import SectionSalarieInfoComplementairesAbstract from '@/generated/sections/SectionSalarieInfoComplementairesAbstract.vue';
  export default defineComponent({
    extends: SectionSalarieInfoComplementairesAbstract,
    components: {},
   
    computed: {
      displayHandicap(): string {
        return this.salarie.statutHandicap > 0 ? "Oui" : "Non";
      },
      displayFiscalite(): string {
        return this.salarie.fiscalite > 0 ? "Oui" : "Non";
      }
    }
     
  })
</script>
